import React, { useState } from "react";
import CountUp from "react-countup";
import ScrollTrigger from "react-scroll-trigger";
import "./srilanka.css";

export default function Male() {
  const [counterOn, setCounterOn] = useState(false);
  return (
    <ScrollTrigger
      onEnter={() => setCounterOn(true)}
      onExit={() => setCounterOn(false)}
    >
      <br />
      <div className="sri-lanka-box1">
        {counterOn && <CountUp start={0} end={44} duration={3} delay={0.3} />}
      </div>
      <br />
      <div className="sri-lanka-box2">
        {counterOn && <CountUp start={0} end={3520} duration={3} delay={0.3} />}
      </div>
      <br />
      <div className="sri-lanka-box3">
        {counterOn && <CountUp start={0} end={4286} duration={3} delay={0.3} />}
      </div>
      <br />
      <div className="sri-lanka-box4">
        {counterOn && <CountUp start={0} end={46} duration={3} delay={0.3} />}%
      </div>
    </ScrollTrigger>
  );
}
